import React from 'react';
import { SmallTitle } from '@indigo-ag/component-module';
import { AgGuarantorProcess, Phase1Input } from '@indigo-ag/schema';
import i18next from 'core/i18n';

import { Ibama, Labor, bgcUtils } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/background-check';
import { EnhancedExpansionPanel } from 'shared';
import { uploadFilesToAgFinancing } from 'features/brazil-grower/components/BrazilGrowerFinance/utils';

export interface GuarantorBackgroundCheckProps {
  guarantorProcess: AgGuarantorProcess;
  updateActions?: {
    updateGuarantorProcess: (updatedBC: Partial<Phase1Input>) => Promise<unknown>;
    toUploadFiles: ReturnType<typeof uploadFilesToAgFinancing>;
  };
  disabled?: boolean;
}

export const GuarantorBackgroundCheck: React.FunctionComponent<GuarantorBackgroundCheckProps> = ({
  guarantorProcess,
  updateActions,
  disabled = false
}) => {
  const { phase1 } = guarantorProcess;

  const ua = updateActions
    ? {
        onSave: (newPhaseInfo: Partial<Phase1Input>) => updateActions.updateGuarantorProcess(newPhaseInfo),
        toUploadFiles: updateActions.toUploadFiles!
      }
    : undefined;

  return (
    <EnhancedExpansionPanel
      title={<SmallTitle className="text-transform-capitalize">{i18next.t('backgroundCheck_title')}</SmallTitle>}
    >
      <div className="width-100">
        <Ibama ibamaInfo={bgcUtils.getIbamaInfoFromPhase(phase1)} updateActions={ua} disabled={disabled} />
        <Labor
          laborInfo={bgcUtils.getLaborInfoFromPhase(phase1)}
          onSave={ua ? ua.onSave : undefined}
          disabled={disabled}
        />
      </div>
    </EnhancedExpansionPanel>
  );
};
